var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProcessing = function SvgProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    clipPath: "url(#processing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.645 7.042a5.093 5.093 0 1 0-8.767 3.513 4.13 4.13 0 0 1 1.127 2.847h5.093a4.05 4.05 0 0 1 1.113-2.827 5.06 5.06 0 0 0 1.434-3.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.552 6.402 7.278 8.31h1.274zM8.552 9.59l1.273-1.914H8.552zM6.005 13.402h5.093v1.274a1.273 1.273 0 0 1-1.273 1.273H7.278a1.273 1.273 0 0 1-1.273-1.273z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "processing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.552.95h16v16h-16z"
  })))));
};
export default SvgProcessing;